module.exports = __webpack_public_path__ + "pc/img/work_list6.e7f67cd7.jpg";